import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
 
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssistBotService {

  searchListBheaviour:BehaviorSubject<any> = new BehaviorSubject([]);
 
  chatHistoryList:any=[];
  chatPinList:any=[];
  chatbotData:any=[];
  chatbotDocFiles:any=[];
  chatbotAudioFiles:any=[];
  historyListBheaviour:BehaviorSubject<any> = new BehaviorSubject({});
  GptConfiguration:any;
  tabPanelBheaviour:BehaviorSubject<any> = new BehaviorSubject({});
  constructor(
    private readonly http: HttpClient
  ) { }

}
